<script>
import HeadingLoader from './HeadingLoader.vue';
import CardLoader from './CardLoader.vue';

import '@rei/cedar/dist/style/cdr-skeleton.css';
import '@rei/cedar/dist/style/cdr-skeleton-bone.css';

const DEFAULT_COLUMNS = {
  xs: 2,
  sm: 4,
};

export default {
  name: 'InlineCardsLoader',
  components: {
    HeadingLoader,
    CardLoader,
  },
  props: {
    count: { type: Number, default: 4 },
    columns: { type: Object, default: DEFAULT_COLUMNS },
    includeHeading: { type: Boolean, default: false },
  },
  computed: {
    componentStyles() {
      const columns = {
        ...DEFAULT_COLUMNS,
        ...this.columns,
      };
      return {
        '--columns-xs': `repeat(${columns.xs}, 1fr)`,
        '--columns-sm': `repeat(${columns.sm}, 1fr)`,
      };
    },
  },
};
</script>
<template>
  <div
    :style="componentStyles"
    class="inline-cards-loader"
  >
    <heading-loader
      v-if="includeHeading"
      class="inline-cards-loader__heading"
    />
    <div class="inline-cards-loader__grid">
      <div
        v-for="(_, index) in count"
        :key="index"
        class="inline-cards-loader__item"
      >
        <card-loader />
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
@import '@rei/cdr-tokens/dist/rei-dot-com/scss/cdr-tokens.scss';
.inline-cards-loader {

  &__grid {
    display: grid;
    grid-template-columns: var(--columns-xs);
    gap: $cdr-space-one-x;

    @include cdr-sm-mq-up {
      grid-template-columns: var(--columns-sm);
      gap: $cdr-space-one-x;
    }
  }

  &__heading {
    margin-bottom: $cdr-space-one-and-a-half-x;
    max-width: 220px;

    @include cdr-sm-mq-up {
      margin-bottom: $cdr-space-two-x;
    }
  }

  &__item {
    max-width: 150px;
  }
}
</style>
